module.exports = require('./lib/styleable')


//////////////////
// WEBPACK FOOTER
// ./~/react-styleable/index.js
// module id = 742
// module chunks = 0